// Town pages: one page per town people search for ("painters in ashford").
// Only state what is true of the business. Reviews are picked by the
// customer's postcode district, so each page shows real local customers.

export const towns = [
  {
    slug: 'ashford',
    path: '/painters-decorators-ashford',
    name: 'Ashford',
    title: 'Painters & Decorators in Ashford, Kent | Paint It Better',
    description:
      'Painters and decorators in Ashford, based ten minutes away in Wye. Interior and exterior painting, new builds, landlords and period homes. Free quotes, 10/10 reviews.',
    heading: 'Painters and Decorators in Ashford',
    intro:
      "Paint It Better is based in Wye, about ten minutes from Ashford town centre, so Ashford is home ground for us. Romeo and the team paint and decorate houses, flats, rental properties and business premises across the town and the villages around it.",
    neighbourhoods: [
      'Kennington', 'Willesborough', 'Kingsnorth', 'Singleton', 'Godinton Park', 'Repton Park',
      'Finberry', 'Chilmington Green', 'Wye', 'Charing', 'Hamstreet', 'Bethersden', 'Pluckley',
    ],
    services: [
      {
        name: 'Interior painting',
        anchor: 'interior-painting',
        text: 'Single rooms to whole houses, including hallways, stairs and landings, with the filling, sanding and priming that makes the finish last.',
      },
      {
        name: 'New builds',
        anchor: 'interior-painting',
        text: "Ashford has plenty of new-build estates. We're used to fresh plaster and can give a new home its first proper decoration once it has had time to dry out.",
      },
      {
        name: 'Exterior painting',
        anchor: 'exterior-painting',
        text: 'Walls, weatherboarding, windows, doors and fascias, with repairs to rotten timber before anything is painted.',
      },
      {
        name: 'Period and village properties',
        anchor: 'period-properties',
        text: 'Older and listed homes in the villages around Ashford, using breathable paints where the building needs them.',
      },
      {
        name: 'Landlords and rentals',
        anchor: 'landlords-rental-properties',
        text: 'Refreshes between tenants, planned around your letting dates.',
      },
      {
        name: 'Offices and shops',
        anchor: 'offices-shops',
        text: 'Small commercial jobs scheduled around trading hours, in phases or out of hours where needed.',
      },
    ],
    reviewPostcodes: ['TN23', 'TN24', 'TN25', 'TN26', 'TN27'],
    faqs: [
      {
        question: 'Do you cover my part of Ashford?',
        answer:
          "Yes. We're based in Wye, so the whole of Ashford and the surrounding villages are within easy reach, from Kennington and Willesborough to Kingsnorth, Chilmington Green, Charing and Hamstreet.",
      },
      {
        question: 'Do you offer free quotes in Ashford?',
        answer:
          'Yes. We offer free, no-obligation quotes. For anything more than a very small job we visit in person, talk through what you want, advise on colours and finishes, then send a clear written quote.',
      },
      {
        question: 'Are you insured, and do you guarantee your work?',
        answer:
          "Yes. We carry appropriate insurance for the work we do. We stand behind our workmanship; if there's anything you're not happy with at the end of the job, we'll put it right.",
      },
    ],
  },
  {
    slug: 'maidstone',
    path: '/painters-decorators-maidstone',
    name: 'Maidstone',
    title: 'Painters & Decorators in Maidstone, Kent | Paint It Better',
    description:
      'Painters and decorators covering Maidstone. Interior and exterior painting for homes, landlords, offices and shops. Free written quotes and 10/10 reviews.',
    heading: 'Painters and Decorators in Maidstone',
    intro:
      'We take on work in Maidstone, about half an hour up the M20 from our base in Wye. Romeo and the team paint and decorate homes, rental properties, offices and shops across the town and the villages around it.',
    neighbourhoods: [
      'Town centre', 'Bearsted', 'Allington', 'Barming', 'Loose', 'Boughton Monchelsea', 'Coxheath',
      'Penenden Heath', 'Shepway', 'Park Wood', 'Weavering', 'Lenham', 'Harrietsham', 'Hollingbourne',
    ],
    services: [
      {
        name: 'Interior painting',
        anchor: 'interior-painting',
        text: 'Single rooms to whole houses, with the filling, sanding and priming that makes the finish last.',
      },
      {
        name: 'Exterior painting',
        anchor: 'exterior-painting',
        text: 'Walls, windows, doors, fascias and front elevations, with repairs to rotten timber before anything is painted.',
      },
      {
        name: 'Offices and shops',
        anchor: 'offices-shops',
        text: "Small commercial projects such as offices, clinics and independent shops. We're used to working around trading hours, staff and customers, and can work in phases or out of hours to keep you open.",
      },
      {
        name: 'Landlords and rentals',
        anchor: 'landlords-rental-properties',
        text: 'Refreshes between tenants, planned around your letting dates.',
      },
      {
        name: 'Period properties',
        anchor: 'period-properties',
        text: 'Older and listed homes, using breathable paints where the building needs them.',
      },
    ],
    reviewPostcodes: ['ME14', 'ME15', 'ME16', 'ME17'],
    faqs: [
      {
        question: 'Do you cover Maidstone?',
        answer:
          'Yes. Maidstone is about half an hour from our base in Wye and we take on jobs across the town and nearby villages such as Bearsted, Coxheath, Loose and Lenham.',
      },
      {
        question: 'Do you take on office and shop work in Maidstone?',
        answer:
          "Yes, we take on small commercial projects such as offices, clinics and independent shops. We're used to working around trading hours, staff and customers, and can schedule work in phases or out of hours where needed.",
      },
      {
        question: 'Do you offer free quotes?',
        answer:
          'Yes. We offer free, no-obligation quotes. For anything more than a very small job we visit in person, talk through what you want, advise on colours and finishes, then send a clear written quote.',
      },
    ],
  },
  {
    slug: 'canterbury',
    path: '/painters-decorators-canterbury',
    name: 'Canterbury',
    title: 'Painters & Decorators in Canterbury, Kent | Paint It Better',
    description:
      'Painters and decorators in Canterbury, about 25 minutes from our base in Wye. Period homes, sash windows, interiors and exteriors. Free quotes, 10/10 reviews.',
    heading: 'Painters and Decorators in Canterbury',
    intro:
      "Canterbury is about 25 minutes from our base in Wye, and many of our customers are in the city and the villages around it. Romeo and the team paint and decorate homes, rental properties and business premises, from period cottages to modern family houses.",
    job: {
      title: 'Sash windows to a Canterbury cottage',
      image: '/images/portfolio/project_08.jpg',
      text: 'Restoration and painting of traditional sash windows on a Canterbury cottage.',
    },
    neighbourhoods: [
      'City centre', 'Wincheap', 'Thanington', "St Dunstan's", 'Hales Place', 'Harbledown', 'Blean',
      'Sturry', 'Chartham', 'Bridge', 'Littlebourne', 'Chilham', 'Barham',
    ],
    services: [
      {
        name: 'Period and listed properties',
        anchor: 'period-properties',
        text: 'Older and listed homes, using breathable paints where the building needs them and careful preparation of original timber and plaster.',
      },
      {
        name: 'Sash and timber windows',
        anchor: 'exterior-painting',
        text: 'Repairing rotten timber, then repainting sash and casement windows so they look right and last.',
      },
      {
        name: 'Interior painting',
        anchor: 'interior-painting',
        text: 'Single rooms to whole houses, with the filling, sanding and priming that makes the finish last.',
      },
      {
        name: 'Exterior painting',
        anchor: 'exterior-painting',
        text: 'Walls, weatherboarding, doors and fascias, with repairs before anything is painted.',
      },
      {
        name: 'Landlords and rentals',
        anchor: 'landlords-rental-properties',
        text: 'Refreshes between tenants, planned around your letting dates.',
      },
      {
        name: 'Offices and shops',
        anchor: 'offices-shops',
        text: 'Small commercial jobs scheduled around trading hours, in phases or out of hours where needed.',
      },
    ],
    reviewPostcodes: ['CT1', 'CT2', 'CT3', 'CT4'],
    faqs: [
      {
        question: 'Do you cover Canterbury?',
        answer:
          "Yes. Canterbury is about 25 minutes from our base in Wye and we work across the city and nearby villages such as Sturry, Chartham, Bridge and Littlebourne.",
      },
      {
        question: 'Can you work on period and listed homes?',
        answer:
          'Yes. We regularly work on period and listed properties that need more careful treatment and breathable paints, and we can repair and repaint sash and timber windows.',
      },
      {
        question: 'Do you offer free quotes?',
        answer:
          'Yes. We offer free, no-obligation quotes. For anything more than a very small job we visit in person, talk through what you want, advise on colours and finishes, then send a clear written quote.',
      },
    ],
  },
];

export const townBySlug = (slug) => towns.find((t) => t.slug === slug);
